// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"04bfd2f1","453":"80743573","872":"5dcde529"}[chunkId] + ".chunk.js";
};